import { render, staticRenderFns } from "./lawsmenu.vue?vue&type=template&id=b2553608&scoped=true&"
import script from "./lawsmenu.vue?vue&type=script&lang=js&"
export * from "./lawsmenu.vue?vue&type=script&lang=js&"
import style0 from "./lawsmenu.vue?vue&type=style&index=0&id=b2553608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2553608",
  null
  
)

export default component.exports